<template  >
<div  class="bg"  >
  <b-container  >

    <b-col cols ="12">
 
  <b-card  class =  "bg" 
   

   
   
   img-src = "../assets/no_borders.jpg"
    img-alt="Card Image"
    img-height="400px;"
    text-variant="dark"
    
    sub-title
    style = "max-width:  ;"
    border-variant="white"

  >
            <h2 class = "header text-center mobile_font "> Γι αυτούς που δεν έχουν όνομα…
				</h2>
        
    
        <br>
       <b-card-text>  
<p  class ="css-exrw3m mobile_text"> Χειμώνας του 2015, κάπου εκεί ξεκίνησε όλη η συζήτηση περί μεταναστευτικού – προσφυγικού προβλήματος στην Ελλάδα και στο σύνολο της Ευρώπης. Κάπου εκεί άρχισαν να προβάλλονται καθημερινά οι εικόνες με τις βάρκες να φτάνουν στα νησιά του ανατολικού Αιγαίου (κυρίως στη Λέσβο, στη Σάμο και στη Χίο). Κάπου εκεί επίσης άρχισαν να ακούγονται οι φωνές για ανθρωπιστική κρίση• φωτογραφίες με νεκρούς μετανάστες να ξεβράζονται στα παράλια των νησιών, ανθρώπους κλεισμένους πίσω από φράχτες να φωνάζουν και να μην ακούγονται, ή τουλάχιστον να μην πολυκαταλαβαίνουμε τι θέλουνε να πούνε. 
</p>

<p  class ="css-exrw3m mobile_text"> Έχουν περάσει πέντε χρόνια από τότε. Η εικόνα δεν έχει αλλάξει και πολύ. Οι φωνές ακόμα εκεί είναι, οι άνθρωποι ακόμα κλεισμένοι, βασανισμένοι να φωνάζουν και πια να μην τους βλέπουμε καν. Η κατάσταση έγινε αποδεκτή, ή μάλλον συνηθίσαμε. Πέντε χρόνια.. και μετρήσαμε πολλούς χιλιάδες νεκρούς (πάνω από 5.000 εκτιμούνται). Μετράμε ακόμα άλλες δεκάδες χιλιάδες κλεισμένους σε hot spot, ή μοντέρνα στρατόπεδα συγκέντρωσης όπως συνηθίζουμε να τα λέμε. 


</p>


 <p  class ="css-exrw3m mobile_text"> Στη Λέσβο υπάρχει μια μεγάλη έκταση με τάφους, οι περισσότεροι από τους οποίους γράφουν πάνω «Άγνωστο αγόρι ετών 6», «άγνωστος άντρας ετών 20», «άγνωστη γυναίκα ετών 30»… άγνωστοι. Αυτή είναι η σημασία. Άγνωστοι, ανώνυμοι, κανένα πρόβλημα.
 </p>

        <p  class ="css-exrw3m mobile_text"> Προσπαθούμε να συλλάβουμε με κάθε τρόπο την όλη κατάσταση. Προσπαθούμε να μιλήσουμε και να αναλύσουμε μια κατάσταση. Δεν θέλουμε να κάνουμε επίκληση σε κανένα συναίσθημα. Ούτε η λογική μπορεί να βοηθήσει εδώ. Η λογική είναι ήδη η λογική του κράτους, η λογική που λέει πως έχουμε να κάνουμε με ένα πρόβλημα και πως πρέπει με τον έναν ή τον άλλον τρόπο να το διαχειριστούμε.
 </p>



         <h3> Πάμε λοιπόν από την αρχή: τι σημαίνει αυτό που λέμε μεταναστευτικό πρόβλημα.

 </h3>

          <p  class ="css-exrw3m mobile_text"> 
Ήδη η ονομασία τοποθετεί το θέμα υπό μια πολύ συγκεκριμένη οπτική. Η οπτική είναι αυτή ενός προβλήματος με την κυριολεκτική σημασία της λέξης. Και όπως κάθε πρόβλημα, έτσι κι αυτό επιδέχεται λύσης. Και μια και μιλάμε για πρόβλημα εθνικής, ή ακόμα καλύτερα, διεθνούς κλίμακας, επιδέχεται και αντίστοιχη αντιμετώπιση. Μέχρι στιγμής, κάθε αντιμετώπιση που έχει εφαρμοστεί κινείται προς έναν πολύ απλό σκοπό: περιορισμός του προβλήματος και αξιοποίησή του είτε ως χαρτί πολιτικής διαπραγμάτευσης είτε ως άμεσης πηγής κέρδους.
 </p>




           <p  class ="css-exrw3m mobile_text"> Τι εννοούμε με το παραπάνω: μιλώντας για το δικό μας ελληνικό κράτος, η πολιτική του κινείται προς την κατεύθυνση του εγκλεισμού των μεταναστών σε στρατόπεδα, ανοιχτά ή κλειστά, μακριά από την άμεση κοινωνική επαφή με τον ντόπιο πληθυσμό προς αποφυγή τριβών που μπορούν είτε αφενός να δυσαρεστήσουν τους ντόπιους είτε αφετέρου ενδέχεται να δημιουργήσουν την επαφή εκείνη με αντιφασιστικά και πολιτικοποιημένα κινήματα υπονομεύει τη μεταναστευτική πολιτική του κράτους. Από την άλλη πλευρά, δημιουργείται ένας νέος οικονομικός κλάδος, με υψηλή κερδοφορία και απορρόφηση. ΜΚΟ λέγεται επίσημα, εμείς θα το ονομάσουμε κλάδο διαχείρισης περιττών πληθυσμών. Εκατομμύρια ευρώ τοποθετούνται μέσω ΜΚΟ και διακρατικών φορέων στα hot spots, δημιουργώντας παράλληλα θέσεις απασχόλησης για μια σειρά απόφοιτων κοινωνιολόγων, ψυχολόγων, κοινωνικών λειτουργών, μεταφραστών κλπ. Τέλος, το ελληνικό κράτος, έχοντας αναλάβει το βάρος διαχείρισης των μεταναστών και της φύλαξης των ανατολικών συνόρων της Ε.Ε. βρίσκεται στην ευχάριστη θέση να μπορεί να χρησιμοποιεί την κατάσταση αυτή προς όφελός του στη διαπραγμάτευση με τις λοιπές χώρες-μέλη της Ε.Ε. για μια σειρά από οικονομικά και πολιτικά θέματα. 

 </p>
           <p  class ="css-exrw3m mobile_text"> Με άλλα λόγια, το πρόβλημα είναι πρόβλημα μόνο για τους ανθρώπους εκείνους που χρησιμοποιούνται για τους πολιτικούς σκοπούς του ελληνικού κράτους και στις πλάτες των οποίων στήνεται μια καινούργια βιομηχανία κέρδους. Πρόβλημα είναι για εκείνες και εκείνους που πεθαίνουν και φυλακίζονται. Για το ελληνικό κράτος, τις ΜΚΟ, τους εργαζόμενους σε αυτές, καθώς και άλλους πολλούς που μισθώνουν μετανάστες με 1 ευρώ την ώρα να δουλεύουν στα χωράφια και τις επιχειρήσεις τους δεν είναι καθόλου πρόβλημα, είναι ευκαιρία. 

 </p>

          <h3> Τι είναι όμως τα hot spots και γιατί αποτέλεσαν πολιτική επιλογή

 </h3>
           <p  class ="css-exrw3m mobile_text"> Η μετανάστευση δεν αποτελεί κάποιο καινούργιο φαινόμενο των 
τελευταίων χρόνων. Και δεν μιλάμε εδώ για την ίδια την έννοια της κίνησης/μετακίνησης που αποτελεί από αρχαιοτάτων χρόνων μια αναφαίρετη ιδιότητα της ανθρώπινης κατάστασης. Μιλάμε για παλαιότερες μετακινήσεις πληθυσμών, μόλις πριν λίγες δεκαετίες. Όλοι και όλες θυμόμαστε αλβανούς, άραβες, πακιστανούς, ρώσους καθώς και ανθρώπους άλλων εθνοτήτων να έρχονται στην Ελλάδα και στην Ευρώπη. Απλώς τότε η ενσωμάτωση αποτελούσε μια ευνοϊκότερη διαδικασία μιας και η δυτική οικονομία βρίσκονταν στην ανάγκη για όλο και περισσότερο εργατικό δυναμικό. Πολλά πράγματα άλλαξαν τις τελευταίες 2-3 δεκαετίες βέβαια. Κρίση, προβληματοθεσία της κρίσης, άνοδος ακροδεξιών πολιτικών, ζήτημα τρομοκρατίας, πόλεμοι ευρείας κλίμακας στα περίχωρα της Ευρώπης. Τα νέα δεδομένα φέρουν και αντίστοιχες προσεγγίσεις για θέματα που πάντοτε ήταν παρόντα. Ένα από αυτά και η μετανάστευση. Ο νέος τρόπος αντιμετώπισης είναι τα στρατόπεδα συγκέντρωσης, επίσημα hot spots.


 </p>
           <p  class ="css-exrw3m mobile_text"> Τα hot spots έρχονται να απαντήσουν σε ένα ζήτημα που στα πλαίσια της κρατικής λογικής δεν χωράει άλλη προσέγγιση: τι κάνουμε με τους πληθυσμούς εκείνους τους οποίους θεωρούμε περιττούς. Τους πληθυσμούς που θεωρούμε πως δεν αξίζουν να συμβιώσουν ισότιμα με τον ντόπιο πληθυσμό. Το hot spot είναι ακριβώς εκείνος ο χώρος ελέγχου, ο χώρος που τοποθετεί την πρωταρχική ερώτηση: ποιος ανήκει και ποιος δεν ανήκει, ποιος μπορεί και ποιος δεν μπορεί να κινηθεί ελεύθερα στην επικράτεια του κράτους. Πριν όμως αποφασιστεί κάτι τέτοιο θα πρέπει πρώτα να δημιουργηθεί η φιγούρα του μετανάστη ως μια φιγούρα εχθρική, ως μια φιγούρα βρώμικη, άθλια και ανάξια να ζήσει όπως εκείνη θέλει. Πράγματι, η αντιμετώπιση πλέον είναι ακριβώς αυτή. Οι άνθρωποι αυτοί αντιμετωπίζονται ως ένας εχθρικός πληθυσμός, ένας πληθυσμός που εισβάλλει με το έτσι θέλω στην ελληνική επικράτεια και ως τέτοιος αντιμετωπίζεται. 

 </p>
           <p  class ="css-exrw3m mobile_text"> Ο πολιτικός λόγος κινείται γύρω από την ασφάλεια του ντόπιου πληθυσμού. Μια ασφάλεια που απειλείται από τους άγνωστους εκείνους, από τους ξένους που εισβάλλουν και μας μολύνουν. Η γλώσσα προδίδει με τους χαρακτηρισμούς της. Μόλυνση, βρωμιά, ανάξιοι, ξένοι και ανώνυμοι. Τα ονόματα στους τάφους μας το υπενθυμίζουν κάθε μέρα. Δεν πρόκειται πια για ανθρώπους. Οι άνθρωποι έχουν ονόματα, μόνο έτσι μπορούν να υπάρχουν. 

 </p>
           <p  class ="css-exrw3m mobile_text"> Πλέον δεν χωρούν υπεκφυγές και ενδιάμεσες θέσεις. Κράτη και κεφάλαιο, πολιτική και οικονομικά συμφέροντα δεν διστάζουν απέναντι σε τίποτα που αμφισβητεί την ύπαρξή τους. Τα πάντα μπορούν να γίνουν για το χρήμα δεν λέμε; Αυτή είναι η εικόνα του κόσμου που έρχεται. Άνθρωποι να πνίγονται, να βασανίζονται, να φυλακίζονται απλά επειδή υπάρχουν, επειδή δεν είναι έλληνες πολίτες με δικαιώματα, ΜΚΟ και αφεντικά να πλουτίζουν στις πλάτες τους και οι υπόλοιποι να συζητάμε πως θα λύσουμε ένα πρόβλημα που η ρίζα του είναι στην ίδια τη μορφή της κοινωνίας μας, στο έθνος και στον καπιταλισμό. 

 </p>

          <h3> Αλλά πάμε λίγο στα πρόσφατα γεγονότα.

 </h3>
 
          <h3> Λέσβος – Χίος 2020

 </h3>


           <p  class ="css-exrw3m mobile_text"> Η κυβέρνηση της ΝΔ ανακοινώνει νέα προσέγγιση για τους ήδη δεκάδες χιλιάδες μετανάστες που είναι εγκλωβισμένοι στα νησιά αυτά: κλειστά κέντρα κράτησης με επίταξη εδαφών. Κοινώς φυλακές, υπερυψωμένα τείχη που μέσα τους θα κλείνονται στιβαγμένοι χιλιάδες άνθρωποι. Οι αντιδράσεις στα νησιά αυτά τεράστιες. Αντιδράσεις διαφορετικού προσανατολισμού. Από φασίστες που θέλουν να τους πετάξουν όλους στη θάλασσα, από ντόπιο πληθυσμό που θεωρεί τον εαυτό του πιο άξιο να μένει και να κινείται ελεύθερος που απηύδησε πια με τόσους μετανάστες στο νησί του, μέχρι και κόσμο που θέλει να συμβιώσει με τους μετανάστες ισότιμα. 

 </p>

           <p  class ="css-exrw3m mobile_text"> Παράλληλα το ελληνικό κράτος έστειλε εκατοντάδες μπάτσους, εξοπλισμό και οχήματα στα παραπάνω νησιά με σκοπό να διαφυλάξουν την υλοποίηση της πολιτικής του. Η απόβαση των παρατεταγμένων μπάτσων από τα πλοία στα λιμάνια της Μυτιλήνης και της Χίου θύμισε απόβαση στρατού σε κατεχόμενα εδάφη. Και η πραγματική εικόνα δεν βρίσκεται μακριά. Πράγματι πρόκειται για μια πολεμικού τύπου διαχείριση. Ο στρατός ήδη έχει εμπλακεί σε εργασίες εκσκαφής στους χώρους που προορίζονται για τις κλειστές φυλακές. Η κατάσταση είναι τόσο τεταμένη όσο και αντιφατική. Και τα άτομα που προορίζονται για τους χώρους αυτούς δεν έχουν φυσικά κανένα λόγο για το μέλλον τους. Κανένα λόγο για το τι θέλουν αυτοί.  

 </p>

           <p  class ="css-exrw3m mobile_text"> Μετά και την φωτιά και την ολοκληρωτική καταστροφή της Μόρια στη Λέσβο πριν λίγους μήνες, το υπουργείο Μετανάστευσης συνέχισε τη ρητορική περί κλειστών κέντρων κράτησης και τη πολιτική «μείωσης των προσφυγικών ροών» προς αποσυμφόρηση των νησιών. Τι σημαίνει το παραπάνω συνοπτικά; Ήδη τις πρώτες επιπτώσεις τις βλέπουμε καθημερινά• οι παράνομες επαναπροωθήσεις μεταναστών στον Έβρο από τον ελληνικό στρατό συνεχίζονται αμείωτα, ενώ οι λίγοι πλέον άνθρωποι που καταφέρνουν να περάσουν τα σύνορα είτε οδηγούνται σε απέλαση με συνοπτικές διαδικασίες είτε στιβάζονται σε κάποιο από τα δεκάδες στρατόπεδα ανά την Ελλάδα. Οι συνθήκες διαβίωσης είναι κάτι παραπάνω από άθλιες, γεγονός που έχει ενταθεί και με πρόσχημα την πανδημία του covid. Βασικές ελλείψεις σε φάρμακα, ρούχα, διατροφή. Καταστροφές σκηνών και πρόχειρων καταλυμάτων από καιρικά φαινόμενα. Απελπισία, κατάθλιψη, αυτοκτονίες…

 </p>


           <h3> Μιλώντας για μια κοινότητα που έρχεται

 </h3>
            <p  class ="css-exrw3m mobile_text"> Σε κάποιο σημείο συνειδητοποιείς πως η ερώτηση του τι θα έκανες εσύ στη θέση τους, τι θα έκανες αν στερούσουν τα μέσα της επιβίωσής σου, αν σε βομβάρδιζαν αν αν  αν… στερείται νοήματος. Το βίωμα δεν υποκαθίσταται από τον υποθετικό λόγο. Αλλά μπορούμε να πούμε δυο πράγματα για όλους εκείνους που αγνοούν τη θέση τους στον κοινωνικό και ιστορικό ορίζοντα. Που ξεχνάνε πως το ελληνικό κράτος συμμετέχει άμεσα και έμμεσα σε πολεμικές επεμβάσεις στη Μέση Ανατολή και στην Αφρική (είτε με την παροχή υλικού, πολεμικών βάσεων, είτε με την άμεση εμπλοκή μονάδων του ελληνικού στρατού). Πως πρέπει να κατανοήσουν πως η πολιτική σου θέση ενέχει δύο προεκτάσεις: είτε συντηρείς τις διαδικασίες αυτού του κόσμου είτε θέτεις φραγμούς και τις ανατρέπεις.

 </p>
            <p  class ="css-exrw3m mobile_text"> Έχουμε να κάνουμε με τις διαδικασίες ενός συστήματος, του καπιταλισμού, που εγγενώς δημιουργεί φτώχεια, εξαθλίωση και περιττό για τις ανάγκες του πληθυσμό. Παράλληλα η κυρίαρχη μορφή ενότητας των κοινωνιών μας είναι εκείνη του έθνους. Μιας μορφής που βασίζεται στο διαχωρισμό του πληθυσμού σε ντόπιους και ξένους, σε κόσμο που ανήκει σε ένα έδαφος και σε κόσμο που δεν ανήκει, σε πολίτες με δικαιώματα και σε σώματα μολυσμένα και ανάξια να ζήσουν. Το κράτος έρχεται να διαχειριστεί όλες αυτές τις αντιφάσεις. Να διαχειριστεί τις ανάγκες και επιθυμίες ενός κόσμου να ζήσει όπως αυτός θέλει, να τις καταστείλει, να τις εκμεταλλευτεί και να τις εξαφανίσει αν έρχονται σε σύγκρουση με τα κυρίαρχα συμφέροντα.

 </p>
            <p  class ="css-exrw3m mobile_text"> Η τοποθέτηση του θέματος τίθεται σε αυτόν τον ορίζοντα. Γιατί όσο η κοινωνία μας έχει αυτή τη μορφή η μετανάστευση θα είναι πάντα ένα πρόβλημα (άλλοτε εμφανές άλλοτε όχι) που πάντοτε όμως επιδέχεται «απάνθρωπων λύσεων». Δεν εγκαλούμε την ηθική καμίας και κανενός απέναντι σε όλα τα παραπάνω. Θέλουμε όμως να προσπαθήσουμε να απομακρυνθούμε από τη λογική του κράτους, από τη λογική που μας λέει πως μπροστά μας έχουμε ένα πρόβλημα που πρέπει με τον έναν ή τον άλλον τρόπο εν τέλει να διαχειριστεί, να λυθεί. Απαντάμε πως η μόνη λύση είναι η διάλυση της πρωταρχικής ερώτησης. Της ερώτησης του ποιος ανήκει εδώ και ποιος δεν ανήκει. Η ερώτηση αυτή έχει τεθεί στην αφετηρία των μοντέρνων κρατικών κοινωνιών και έχουμε και οι ίδιοι ξεχάσει την αφετηρία της. 

 </p>
            <p  class ="css-exrw3m mobile_text"> Μιλάμε, ή μάλλον καλύτερα προσπαθούμε να συλλάβουμε μια κοινότητα που δεν χωρά διακρίσεις ντόπιου και ξένου. Δεν χωρά εκμετάλλευση ανθρώπου από άνθρωπο. Δεν χωρά διαχωρισμούς κανονικού και μη – κανονικού. Όλες και όλοι είμαστε ισότιμοι και ελεύθεροι να ζήσουμε όπως εμείς θέλουμε. Η εξαθλίωση που βιώνουν οι μετανάστες, οι άθλιες συνθήκες για τον κόσμο εκείνο, ντόπιο και ξένο, που στερείται τα βασικά μέσα επιβίωσης, η εικόνα των μπάτσων να βαράνε αδιάκριτα όποιον και όποια τολμάει να υψώσει τη φωνή της/του. Χιλιάδες εικόνες της ζοφερής εποχής που ζούμε. 

 </p>
            <p  class ="css-exrw3m mobile_text"> Αλλά εδώ ακριβώς ζούμε. Κάθε μέρα αυτές οι εικόνες θα αναγεννούν την επιθυμία μας να ζήσουμε διαφορετικά. Να διαλύσουμε όλες τις μορφές αυτού του κόσμου. Να χτίσουμε στο σήμερα κοινότητες ανθρώπων, κοινότητες συντρόφων, κοινότητες πολυεθνικές και αυτόνομες. Μέχρι εκείνη τη μέρα θα ουρλιάζουμε

 </p>


       
<h2 class = "text-center">Σκατά σε κράτος και εθνικό κορμό</h2>
<h2 class = "text-center">Καμία θυσία για τα κέρδη του κεφαλαίου </h2>
<h2 class = "text-center">Άμεσο κλείσιμο των στρατοπέδων και ελεύθερη μετακίνηση για όλες και όλους</h2>


        
        
      
</b-card-text>
</b-card>

  
    </b-col>
  

  </b-container>
</div>

</template>

<script>





export default {
  name: 'Fascism',
  data(){
    return {
      mainProps: { blank: true,  width: 75, height: 75, class: 'm1' }
    }
  }
  
}

  

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  body, html {
    height: 100%;
  }
  .container {
    max-width:auto;

  }

  .header {
      font-size :50px;
  }
  .bg {
    padding-top  : 2%;
    /* The image used */
    background-color : rgb(255, 255, 255);

    /* Half height */
    height: 20%;
   

    /* Center and scale the image nicely */
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .bob {
    height : 20%;

  }
      .css-exrw3m {
    
   
    font-family: nyt-imperial,georgia,'times new roman',times,serif;
    font-size: 1.125rem;
    line-height: 1.5625rem;
    text-align :justify;

    width: 100%;
  
  }

      @media screen and (min-width: 720px)  {
        .mobile-break { display: none; }
        
        
        
    }
    @media screen and (max-width: 720px) {
        .button_center {
          text-align: center; 
          

    }
      .mobile_text {
    
   
    font-family: nyt-imperial,georgia,'times new roman',times,serif;
    font-size: 15px;
    line-height: 1.5625rem;
    text-align :justify;
    width: 100%;

  
  } 
        .mobile_font {

        font-size:30px;
      }
    .card-title {
      font-size: 13px;
      text-align: center;


    
    }
    .container {
      max-width :auto ;
      padding-right:1px;
      padding-left:1px;
      

    } 
    
    }
  
</style>
